import axios from "axios";
import * as crypto from "crypto-js";
import config from "./config";
const rules = {
  email: [
    (v: any) => !!v || "El E-mail es obligatorio",
    (v: any) => /.+@.+/.test(v) || "El E-mail no es valido",
  ],
  password: [
    (v: any) => !!v || "La contraseña es obligatoria",
    (v: any) =>
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&]{8,}$/
        .test(v) ||
      "La contraseña debe contener al menos 8 caracteres, una mayúscula, una minúscula, un número y un carácter especial (! @ $ % & ? *)",
  ],
  name: [
    (v: any) => !!v || "El nombre es obligatorio"
  ],
  entityType: [
    (v: any) => v != null || "El tipo de entidad debe ser obligatorio"
  ],
  nif: [
    (v: any)=> !!v || "El NIF es obligatorio"
  ],
  privacyPolity: [
    (v: any) => !!v || "es obligatorio aceptar las politicas de privacidad"
  ],
  useCondition: [
    (v: any) => !!v || "es obligatorio aceptar las condiciones de uso"
  ]
};
function codificar(cookie: string, cryptoKey: string){
  return crypto.AES.encrypt(cookie, cryptoKey)
}
function decodificar(cookie: string, cryptoKey: string){
  const decrypt = crypto.AES.decrypt(cookie, cryptoKey)
  return JSON.parse(decrypt.toString(crypto.enc.Utf8))
}
const TipoEntidad = [
  {key: 0, value: 'Persona Física' },
  {key: 1, value: 'Persona Jurídica'}
]
export default {
  rules: rules,
  codificar: codificar,
  decodificar: decodificar,
  TipoEntidad:TipoEntidad
};
